import { render, staticRenderFns } from "./materialAccountDetail.vue?vue&type=template&id=44185c2e&scoped=true"
import script from "./materialAccountDetail.vue?vue&type=script&lang=js"
export * from "./materialAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./materialAccountDetail.vue?vue&type=style&index=0&id=44185c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44185c2e",
  null
  
)

export default component.exports